import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "snippet-text",
  "use": "snippet-text-usage",
  "viewBox": "0 0 78.62 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 78.62 56\" id=\"snippet-text\"><path fill=\"currentColor\" d=\"M46.21 18.5h-4.23v20.58h5.13v4.91H31.73v-4.91h4.91V18.5h-4.02v5.29h-4.61v-10.1h22.6v10.1h-4.35V18.5h-.05zM78.62 28.06L59.27 56l-4.17-4.64 16.46-23.19-16.5-22.91L59.28 0l19.34 28.06M0 27.94L19.36 0l4.16 4.64L7.06 27.83l16.5 22.91L19.34 56 0 27.94\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/snippet-text.svg
// module id = Zq7M
// module chunks = 39 44